import { jsx as _jsx } from "react/jsx-runtime";
import styled, { ThemeProvider } from 'styled-components';
import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UIProgress from 'UIComponents/progress/UIProgress';
import { OZ, CALYPSO, KOALA } from 'HubStyleTokens/colors';
import { BUTTON_RADIUS } from 'HubStyleTokens/sizes';
const ExceededOneTwentyFiveBar = styled(UIProgress).withConfig({
  displayName: "StyledProgressBar__ExceededOneTwentyFiveBar",
  componentId: "sc-16w6k9x-0"
})(["@keyframes moving-gradient{0%{background-position:left bottom;}100%{background-position:right bottom;}}background:linear-gradient(135deg,", " 0%,", " 50%,", " 100%) repeat;background-size:50% 100%;height:", "px !important;animation:moving-gradient 1s infinite linear;cursor:", ";"], OZ, CALYPSO, OZ, //@ts-expect-error passing height as an additional prop to the styled component
props => props.height, //@ts-expect-error passing height as an additional prop to the styled component
props => props.handleClickAttainmentBar ? 'pointer' : 'cursor');
const BetweenOneHundredAndOneTwentyFiveBar = styled(UIProgress).withConfig({
  displayName: "StyledProgressBar__BetweenOneHundredAndOneTwentyFiveBar",
  componentId: "sc-16w6k9x-1"
})(["height:", "px;cursor:", ";"], //@ts-expect-error passing height as an additional prop to the styled component
props => props.height, //@ts-expect-error passing height as an additional prop to the styled component
props => props.handleClickAttainmentBar ? 'pointer' : 'cursor');
const UnderOneHundredDiv = styled.div.withConfig({
  displayName: "StyledProgressBar__UnderOneHundredDiv",
  componentId: "sc-16w6k9x-2"
})(["background-color:", ";border-radius:", ";cursor:", ";"], KOALA, BUTTON_RADIUS, //@ts-expect-error passing height as an additional prop to the styled component
props => props.handleClickAttainmentBar ? 'pointer' : 'cursor');
const UnderOneHundredBar = styled.div.withConfig({
  displayName: "StyledProgressBar__UnderOneHundredBar",
  componentId: "sc-16w6k9x-3"
})(["background-color:", ";border-radius:", ";height:", "px;width:", "%;"], OZ, BUTTON_RADIUS, //@ts-expect-error passing height as an additional prop to the styled component
props => props.height, props => props.theme.attainment);
export const StyledProgressBar = ({
  attainmentPercentage,
  height,
  handleClickAttainmentBar
}) => {
  const attainment = attainmentPercentage ? Math.max(attainmentPercentage, 0) : 0;
  const ariaLabel = String(attainment);

  if (!attainment || attainment < 100) {
    return /*#__PURE__*/_jsx(UIAbstractProgress, {
      render: () => /*#__PURE__*/_jsx(UnderOneHundredDiv //@ts-expect-error passing handleClickAttainmentBar as an additional prop to the styled component
      , {
        handleClickAttainmentBar: handleClickAttainmentBar,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          theme: {
            attainment
          },
          children: /*#__PURE__*/_jsx(UnderOneHundredBar //@ts-expect-error passing height as an additional prop to the styled component
          , {
            height: height
          })
        })
      }),
      "aria-label": ariaLabel
    });
  }

  if (attainment < 125) {
    return /*#__PURE__*/_jsx(BetweenOneHundredAndOneTwentyFiveBar //@ts-expect-error passing height as an additional prop to the styled component
    , {
      height: height,
      handleClickAttainmentBar: handleClickAttainmentBar,
      role: "presentation",
      wrapperClassName: "m-bottom-0 table-progress",
      use: "success",
      value: Math.max(attainment, 0),
      "aria-label": ariaLabel
    });
  }

  return /*#__PURE__*/_jsx(ExceededOneTwentyFiveBar //@ts-expect-error passing height as an additional prop to the styled component
  , {
    height: height,
    handleClickAttainmentBar: handleClickAttainmentBar,
    role: "presentation",
    wrapperClassName: "m-bottom-0 table-progress",
    use: "success",
    value: 0,
    "aria-label": ariaLabel
  });
};